import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios'
import './ChatBotCohort.css';
import { presetTree } from './ChatBotPresets';
import ShowImg from './ShowImg';
import SelectMsg from './SelectMsg';
import GroupEditMsg from './GroupEditMsg';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function ChatBotCohort(){
  useEffect(() => {
    const root = presetTree['root'];
    setMsg([{
      role: 'bot',
      text: root.prompt,
      type: 'preset',
      presetKey: 'root',
      options: root.options
    }]);
  }, []);

  useEffect(() => {
          fetch('/api/clear_uploads', { method: 'POST' });
  }, []);

  const [msg, setMsg] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [detectCols, setDetectCols] = useState([]);
  const [figList, setFigList] = useState([]);
  const [plotExist, setPlotExist] = useState(false);
  const [pendingSteps, setPendingSteps] = useState(null);
  const [plotPending, setPlotPending] = useState(false);
  const [colname, setColname] = useState([]);
  const [figSum, setFigSum] = useState([]);
  const hasTriggeredQABot = useRef(false);
  const [method, setMethod] = useState('');

  useEffect(() => {
    if (pendingSteps && detectCols && Object.keys(detectCols).length > 0) {
      // 有 pending 且 detectCols 已更新
      handleMultiLLMSteps({ steps: pendingSteps });
      setPendingSteps(null); // 清掉避免重複執行
    }
  }, [pendingSteps, detectCols]);

  useEffect(() => {
    if (figList && figList.length > 0) {
      console.log("figList updated:", figList);
      setPlotPending(false);
    }
  }, [figList]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleUserQAInput(input, method, figSum, 
        detectCols['survival_col'], detectCols['duration_col'], detectCols['factor_col'], 
        detectCols['id_col'], detectCols['mainfactor_col']);
    }
  };

  const sendByClick = async (prompt, currentMsgs) => {
    setMsg(currentMsgs);
    setLoading(true);
    try {
      const res = await axios.post('/api/chat', {
        message: prompt,
        page: 'cohort',
      });
      setMsg([...currentMsgs, { role: 'bot', text: res.data.reply }]);
    } finally {
      setLoading(false);
    }
  };

  const getColNames = async () => {
    try{
      const res = await axios.post('/api/get_col_name',{
        page: 'cohort_single',
      });
      return res.data.columns;
    } catch(err){
      console.error(err);
      return [];
    }
  }

  const getColNamesNoID = async () => {
    try{
      const res = await axios.post('/api/get_col_name_noid',{
        page: 'cohort_single',
      });
      return res.data.columns;
    } catch(err){
      console.error(err);
      return [];
    }
  }

  const getColNamesCat = async () => {
    try{
      const res = await axios.post('/api/get_col_name_categorical',{
        page: 'cohort_single',
      });
      return res.data.columns;
    } catch(err){
      console.error(err);
      return [];
    }
  }

  const getColNamesNum = async () => {
    try{
      const res = await axios.post('/api/get_col_name_numerical',{
        page: 'cohort_single',
      });
      return res.data.columns;
    } catch(err){
      console.error(err);
      return [];
    }
  }

  const getColNamesFeat = async () => {
    try{
      const res = await axios.post('/api/get_col_name',{
        page: 'cohort_feature',
      });
      return res.data.columns;
    } catch(err){
      console.error(err);
      return [];
    }
  }

  const handleSelectSubmit = (selectedValue, presetKey, fromStep, steps, num_step) => {
    console.log('submit:', selectedValue, presetKey, fromStep, steps, num_step);
    setMsg(prev => [
      ...prev,
      { role: 'user', text: `I picked: ${Array.isArray(selectedValue) ? selectedValue.join(', ') : selectedValue}` }
    ]);
  
    console.log("使用者選擇：", selectedValue);
    if (fromStep?.llmLabel) {
      setDetectCols(prev => ({
        ...prev,
        [fromStep.llmLabel]: selectedValue
      }));
    }
  
    setPendingSteps(steps.slice(num_step + 1));

  };

  const handleUserQAInput = async (inputText, method, summary, surv, dura, factor, id) => {
    console.log("text input:", inputText)
    if (!inputText.trim()) return; //.trim() -> remove blank spaces

    const newMsg = [...msg, {role:'user', text:inputText}];
    setMsg(newMsg);
    setInput('');
    try {
      const res = await axios.post('/api/chat_qa', 
        { input: inputText,
          method:method,
          sum:summary,
          survival_col:surv,
          duration_col:dura,
          factor_col:factor,
          id_col:id });
      
      if (res.data.type === 'text') {
        setMsg(prev => [...prev, { role: 'bot', text: res.data.data }]);
      
      } else if (res.data.type === 'plot') {
        console.log("PLOT")
        if (res.data.data && res.data.data.length > 0) {
          setFigList(res.data.data);      
          console.log("NEW FIG")
          setPlotExist(true);             
          setPlotPending(false);
        } else {
          setMsg(prev => [...prev, { role: 'bot', text: '⚠️ There are currently no charts available for display.' }]);
        }
      }
    } catch (err) {
      console.error(err);
      setMsg(prev => [...prev, { role: 'bot', text: '⚠️ An error has occurred. Please try again later.' }]);
    }
  };

  const handleMultiLLMSteps = async (opt) => {
    if (!opt.steps) return;
    if (opt.id){
      setMethod(opt.id);
    }
    console.log("opt.id:", method)
    for (let i = 0; i < opt.steps.length; i++) {
      const step = opt.steps[i];
      //LLM START
      if (step.llmDetect) {
        const loadingMsg = { role: 'bot', text: step.prompt || 'Analyzing...', tempId: `loading-${i}` };
        setMsg(prev => [...prev, loadingMsg]);
  
        try {
          const res = await axios.post(step.llmEndpoint, { page: 'cohort' });
  
          if (res.data.success) {
            const col = res.data[step.llmLabel];
  
            const confirmBotMsg = {
              role: 'bot',
              text: `LLM identified “${col}” as ${step.llmLabel}. Is that correct?`,
              type: 'confirm',
              confirmOptions: [
                {
                  label: 'Yes, continue',
                  onClick: () => {
                    setMsg(prev => [
                      ...prev,
                      { role: 'user', text: 'Yes, continue' }
                    ]);
                    setDetectCols(prev=>({
                      ...prev,
                      [step.llmLabel]:col
                    }))
                    setPendingSteps(opt.steps.slice(i + 1));
                  }
                },
                {
                  label: 'No, I will pick manually',
                  onClick: async () => {
                    const fallbackNode = presetTree[step.fallbackNext];
                    let colist;
                    console.log(step.fallbackNext)
                    if (step.fallbackNext === "catfactor_manual_select"){
                      colist = await getColNamesCat();}
                    else if (step.fallbackNext === "numfactor_manual_select"){
                      colist = await getColNamesNum();}
                    else if (step.fallbackNext === "fixfactor_manual_select"){
                      colist = await getColNamesNoID();
                    }
                    else if (step.fallbackNext === "duration_manual_feat_select"){
                      colist = await getColNamesFeat();
                    }
                    else if (step.fallbackNext === "survival_manual_feat_select"){
                      colist = await getColNamesFeat();
                    }
                    else if (step.fallbackNext === "id_manual_feat_select"){
                      colist = await getColNamesFeat();
                    }
                    else{
                      colist = await getColNames();
                    }
                    console.log("col_names", colist)
                    const fallbackBotMsg = {
                      role: 'bot',
                      text: fallbackNode.prompt,
                      type: 'select',
                      multi: fallbackNode.multi || false,
                      presetKey: step.fallbackNext,
                      options: colist.map(col => ({ id: col, label: col })),
                      fromStep:step,
                      steps:opt.steps,
                      num_step:i,
                    };
                    setMsg(prev => [
                      ...prev,
                      { role: 'user', text: 'No, I will pick manually' },
                      fallbackBotMsg
                    ]);
                    
                  }
                }
              ]
            };
  
            setMsg(prev =>
              [...prev.filter(m => m.tempId !== `loading-${i}`), confirmBotMsg]
            );
            return;
          } else {
            console.log('failed')
            const fallbackNode = presetTree[step.fallbackNext];
            let colist;
            console.log(step.fallbackNext)
            if (step.fallbackNext === "catfactor_manual_select"){
              colist = await getColNamesCat();}
            else if (step.fallbackNext === "numfactor_manual_select"){
              colist = await getColNamesNum();}
            else if (step.fallbackNext === "fixfactor_manual_select"){
                    colist = await getColNamesNoID();}
            else if (step.fallbackNext === "duration_manual_feat_select"){
              colist = await getColNamesFeat();
            }
            else if (step.fallbackNext === "survival_manual_feat_select"){
              colist = await getColNamesFeat();
            }
            else if (step.fallbackNext === "id_manual_feat_select"){
              colist = await getColNamesFeat();
            }
            else{
              colist = await getColNames();
            }
            console.log("col_names", colist)
            const fallbackBotMsg = {
              role: 'bot',
              text: fallbackNode.prompt,
              type: 'select',
              multi: fallbackNode.multi || false,
              presetKey: step.fallbackNext,
              options: colist.map(col => ({ id: col, label: col })),
              fromStep:step,
              steps:opt.steps,
              num_step:i,
            };
            setMsg(prev => [
              ...prev,
              { role: 'bot', text: 'Please pick manually' },
              fallbackBotMsg
            ])
            return;
          }
        } catch (e) {
          console.error('偵測失敗', e);
          handlePresetStep(step.fallbackNext, 'fallback triggered');
          return;
        }
      }
      //LLM END
      //PLOT START
      else if (step.plotImg){
        if (plotPending) return;
        const loadingMsg = { role: 'bot', text: step.prompt || 'Plotting...', tempId: `loading-${i}` };
        setMsg(prev => [...prev, loadingMsg]);
        try {
          console.log("🔍 detectCols:", detectCols);
          setPlotPending(true);
          const res = await axios.post(step.llmEndpoint, { ...detectCols, page: 'cohort' });
          setFigList(res.data.figs);
          setFigSum(res.data.sum);
          setPlotExist(true);
          setPendingSteps(opt.steps.slice(i + 1));
        } catch (e) {
          console.error('繪圖失敗', e);
          handlePresetStep(step.fallbackNext, 'fallback triggered');
          setMsg(prev => [
            ...prev,
            {
              role: 'bot',
              text: 'Something went wrong. Please make sure your data is in a valid and analyzable format.'
            }
          ]);
          return;
        }
      }
      //PLOT END
      //QA BOT START
      else if (step.qa_bot && !hasTriggeredQABot.current){
        hasTriggeredQABot.current = true;
        console.log("QA Step Triggered:", step.prompt);
        const Msg = { role: 'bot', text: step.prompt};
        setMsg(prev => [...prev, Msg]);
        // handleUserQAInput()
        return;
      }

      //PICK COL
      else if (step.pickCol){
        const colist = await getColNamesNoID();
        const pickColBotMsg = {
          role: 'bot',
          text: step.prompt,
          type: 'select',
          multi: step.multi || false,
          presetKey: step.llmLabel || 'pick_col',
          options: colist.map(col => ({ id: col, label: col })),
          fromStep: step,
          steps: opt.steps,
          num_step: i,

        };
        setMsg(prev => [
          ...prev.filter(m => m.tempId !== `loading-${i}`),
          pickColBotMsg
        ]);

        return;
    }
    // GROUP EDIT
    else if (step.groupEdit){
      const loadingMsg = { role: 'bot', text: step.prompt || 'Grouping...', tempId: `loading-${i}` };
      setMsg(prev => [...prev, loadingMsg]);
      try {
        const colist = await getColNamesNoID();
        const a_col = detectCols?.mainfactor_col || null;
        const res = await axios.post(step.llmEndpoint, {
          a_col,
          columns: colist,
          page: 'cohort_single',
          similarity_threshold: 85,
          keep_singletons_as_groups: true
        });
        const grouping = res.data.grouping; // {groups, ungrouped, excluded}
        const lowConfidenceItems = res.data.low_confidence_items || res.data.low_confidence_items || [];
        const botMsg = {
          role: 'bot',
          type: 'group_edit',
          title: step.prompt || 'Please confirm or adjust grouping.',
          grouping,
          lowConfidenceItems,
          onConfirm: (editedGrouping) => {
            setMsg(prev => [...prev, { role: 'user', text: 'Confirm grouping' }]);

            setDetectCols(prev => ({
              ...prev,
              [step.groupingLabel || 'grouping']: editedGrouping
            }));
            setPendingSteps(opt.steps.slice(i + 1));

          }
        };
        setMsg(prev => [...prev.filter(m => m.tempId !== `loading-${i}`), botMsg]);
          return; 
      } catch (e) {
        console.error('Grouping failed', e);
        setMsg(prev => [...prev, { role: 'bot', text: 'Grouping failed. Please pick manually.' }]);
        return;
      }

    }
    //feature fusion
    else if(step.featureFusion){
      const loadingMsg = {
        role: 'bot',
        text: step.prompt || 'Processing...',
        tempId: `loading-${i}`
      };

      setMsg(prev => [...prev, loadingMsg]);

      try {
        const res = await axios.post(step.llmEndpoint, {
          page: 'cohort'
        });
        console.log("feature fusion success:", res.data);

        setPendingSteps(opt.steps.slice(i + 1));

      } catch (e) {

        console.error("feature fusion failed:", e);
        handlePresetStep(step.fallbackNext, 'fallback triggered');
        setMsg(prev => [
          ...prev,
          {
            role: 'bot',
            text: 'Feature fusion failed. Please check your .pt file.'
          }
        ]);

        return;

      }
    }

    }
  };
  

  const handlePresetStep = async (opt) => {
    console.log("button：", opt.label);
    console.log("nodeKey:", opt.next);
    console.log("finalPrompt:", opt.final_prompt);
    console.log("opt 傳進來是：", opt);

    // Handle llm detection for columns
    if (opt.steps) {
      await handleMultiLLMSteps(opt);
      console.log(detectCols);
      return;
    } else if (opt.final_prompt) {
      const newMsg = [...msg, { role: 'user', text: opt.label }];
      sendByClick(opt.final_prompt, newMsg);
    } else if (presetTree[opt.next]) {
      const nextNode = presetTree[opt.next];
      const botMsg = {
        role: 'bot',
        text: nextNode.prompt,
        type: 'preset',
        presetKey: opt.next,
        options: nextNode.options,
      };
      setMsg(prev => [...prev, { role: 'user', text: opt.label }, botMsg]); 
    } else { 
      console.warn(`presetTree 中找不到 key: ${opt.next}`);
    };
  };
  

return (
  <div>
  <div className="chatbot-container">
      <div className="chatbot-header">
        <h3>ChatBot</h3>
      </div>
      <div className="chat-window">
      {msg.map((msg, i) => (
        <div key={i} className={`message ${msg.role}`}>
          <div className="bubble">
            <ReactMarkdown>
              {msg.text}
            </ReactMarkdown>
            {msg.type === 'preset' && (
              <div className="inline-preset-buttons">
                {msg.options.map(opt => (
                  <button
                    key={opt.id ? opt.id : `fallback-${i}`}
                    onClick={() => handlePresetStep(opt)}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            )}
            {msg.type === 'confirm' && (
              <div className="confirm-buttons">
                {msg.confirmOptions.map((opt, idx) => (
                  <button key={idx} onClick={opt.onClick}>
                    {opt.label}
                  </button>
                ))}
              </div>
            )}
            {msg.type === 'select' && (
              <SelectMsg
              key={`select-${i}`}
              prompt={msg.prompt}
              options={msg.options}
              multi={msg.multi}
              presetKey={msg.presetKey}
              onSubmit={handleSelectSubmit}
              fromStep={msg.fromStep}
              steps={msg.steps}
              num_step={msg.num_step}></SelectMsg>
            )}
            {msg.type === 'group_edit' && (
              <GroupEditMsg
                key={`group-edit-${i}`}
                title={msg.title}
                grouping={msg.grouping}
                lowConfidenceItems={msg.lowConfidenceItems}
                onConfirm={msg.onConfirm}
              />
            )}
          </div>
        </div>
      ))}
        {loading && <div className="loading">Bot is typing...</div>}
      </div>

      <div className="chat-input">
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type a message..."
        />
        <button
          onClick={() =>
            handleUserQAInput(
              input,
              method,
              figSum,
              detectCols['survival_col'],
              detectCols['duration_col'],
              detectCols['factor_col'],
              detectCols['id_col'],
              detectCols['mainfactor_col']
            )
          }
        >Send</button>
      </div>
    </div>
    <div className='plot-container'>
    {plotPending ? (
      <div className="loading">Generating figure...</div>
    ) : (
      figList?.length > 0 ? (
        <ShowImg fig_list={figList} />
      ) : (
        <div>No figure</div>
      )
)}

    </div>
  </div>
  );
};

